import type { SxProps, Theme } from '@mui/material/styles';
import { BUBBLE_BORDER_RADIUS, BUBBLE_TAIL_SIZE, bgColor } from './utils/consts.ts';

export const containerSx = (isUser: boolean): SxProps<Theme> => ({
  justifyContent: 'flex-end',
  display: 'flex',
  width: '100%',
  flexDirection: isUser ? 'row' : 'row-reverse',
  alignItems: 'flex-end',
});

export const bubbleSx = (isUser: boolean, isFullWidth = false): SxProps<Theme> => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  maxWidth: isFullWidth ? '100%' : '85%',
  flexGrow: isFullWidth ? 1 : 0,
  overflowWrap: 'break-word',
  overflow: 'auto',
  p: 2,
  fontWeight: theme => theme.typography.fontWeightRegular,
  lineHeight: theme => theme.typography.body1.lineHeight,
  letterSpacing: theme => theme.typography.h1.letterSpacing,
  borderRadius: theme =>
    isUser
      ? theme.spacing(BUBBLE_BORDER_RADIUS, BUBBLE_BORDER_RADIUS, 0, BUBBLE_BORDER_RADIUS)
      : theme.spacing(BUBBLE_BORDER_RADIUS, BUBBLE_BORDER_RADIUS, BUBBLE_BORDER_RADIUS, 0),
  backgroundColor: theme => bgColor(theme, isUser),
  fontSize: theme => theme.typography.body1.fontSize,
  '& h2': { fontSize: 16 },
  '& h3': {
    fontSize: 15,
    fontWeight: theme => theme.typography.fontWeightBold,
    lineHeight: theme => theme.typography.h3.lineHeight,
    letterSpacing: theme => theme.typography.h1.letterSpacing,
  },
});

export const summarySx: SxProps<Theme> = {
  gap: 0.5,
  mb: 0.5,
};

export const detailsToggleSx: SxProps<Theme> = {
  alignSelf: 'flex-start',
  gap: 0.5,
  borderRadius: 2,
  color: 'primary.main',
  fontSize: 14,
  lineHeight: '20px',
  '& .MuiSvgIcon-root': { fontSize: 14 },
  '&.Mui-focusVisible': { outline: '2px solid', outlineColor: 'primary.main', outlineOffset: '2px' },
};

export const richContentActionsSx: SxProps<Theme> = {
  gap: 1.5,
  py: 2,
  width: '100%',
};

export const tailSx = (isUser: boolean): SxProps<Theme> => ({
  width: 0,
  height: 0,
  borderStyle: 'solid',
  borderWidth: theme =>
    isUser
      ? theme.spacing(0, BUBBLE_TAIL_SIZE, BUBBLE_TAIL_SIZE, 0)
      : theme.spacing(0, 0, BUBBLE_TAIL_SIZE, BUBBLE_TAIL_SIZE),
  borderColor: theme => `transparent transparent ${bgColor(theme, isUser)} transparent`,
  transform: 'rotate(0deg)',
});
